(function () {
  'use strict';

  var ROOT_ID = 'MembershipBenefitsNudge';

  function nowMs() {
    return Date.now();
  }

  function getDismissedAt(storageKey) {
    try {
      var raw = window.localStorage.getItem(storageKey);
      var parsed = Number(raw || 0);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    } catch (_e) {
      return 0;
    }
  }

  function setDismissedAt(storageKey, ts) {
    try {
      window.localStorage.setItem(storageKey, String(ts));
    } catch (_e) {
      // no-op
    }
  }

  function shouldSuppress(storageKey, cooldownHours) {
    var last = getDismissedAt(storageKey);
    if (!last) return false;
    var cooldownMs = Math.max(1, cooldownHours) * 60 * 60 * 1000;
    return nowMs() - last < cooldownMs;
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;

    if (window.EPIC_GARDENING && window.EPIC_GARDENING.isGreenhouseMember === true) {
      root.remove();
      return;
    }

    var enableModal = String(root.dataset.enableModal || '').toLowerCase() === 'true';
    var dismissBtn = root.querySelector('[data-membership-nudge-dismiss]');
    var quickLink = root.querySelector('[data-membership-nudge-link]');

    var showDelayMs = Number(root.dataset.showDelayMs || 2500);
    var cooldownHours = Number(root.dataset.cooldownHours || 48);
    var storageKey = root.dataset.storageKey || 'eg_membership_nudge_dismissed_at_v1';

    if (shouldSuppress(storageKey, cooldownHours)) {
      return;
    }

    function dismissNudge() {
      setDismissedAt(storageKey, nowMs());
      root.classList.remove('is-visible');
    }

    if (dismissBtn) {
      dismissBtn.addEventListener('click', function (event) {
        event.preventDefault();
        dismissNudge();
      });
    }

    if (quickLink) {
      quickLink.addEventListener('click', function () {
        // Prevent immediate reappearance after navigating back.
        setDismissedAt(storageKey, nowMs());
      });
    }

    if (!enableModal) {
      window.setTimeout(function () {
        if (!shouldSuppress(storageKey, cooldownHours)) {
          root.classList.add('is-visible');
        }
      }, Math.max(0, showDelayMs));
      return;
    }

    var openBtn = root.querySelector('[data-membership-nudge-open]');
    var modal = root.querySelector('[data-membership-nudge-modal]');
    var backdrop = root.querySelector('[data-membership-nudge-backdrop]');
    var closeButtons = root.querySelectorAll('[data-membership-nudge-close]');
    var joinBtn = root.querySelector('[data-membership-nudge-join]');

    if (!openBtn || !modal || !backdrop) return;

    // Keep the trigger tab in place, but render modal/backdrop at body level so
    // fixed positioning is always viewport-centered.
    if (backdrop.parentNode !== document.body) {
      document.body.appendChild(backdrop);
    }
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var isOpen = false;
    var activeBeforeOpen = null;

    function openModal() {
      if (isOpen) return;
      isOpen = true;
      activeBeforeOpen = document.activeElement;
      root.classList.add('is-open');
      document.body.classList.add('membership-benefits-nudge-open');
      openBtn.setAttribute('aria-expanded', 'true');
      backdrop.classList.add('is-open');
      modal.classList.add('is-open');
      backdrop.hidden = false;
      modal.hidden = false;

      var focusables = getFocusable(modal);
      var first = focusables[0];
      if (first) first.focus();
    }

    function closeModal(opts) {
      if (!isOpen) return;
      var shouldDismiss = !opts || opts.persistDismiss !== false;
      isOpen = false;
      root.classList.remove('is-open');
      document.body.classList.remove('membership-benefits-nudge-open');
      openBtn.setAttribute('aria-expanded', 'false');
      backdrop.classList.remove('is-open');
      modal.classList.remove('is-open');
      backdrop.hidden = true;
      modal.hidden = true;

      if (shouldDismiss) {
        dismissNudge();
      }

      if (activeBeforeOpen && typeof activeBeforeOpen.focus === 'function') {
        activeBeforeOpen.focus();
      }
    }

    function onKeydown(event) {
      if (!isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal({ persistDismiss: true });
        return;
      }

      if (event.key !== 'Tab') return;

      var focusables = getFocusable(modal);
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    openBtn.addEventListener('click', function () {
      openModal();
    });

    backdrop.addEventListener('click', function () {
      closeModal({ persistDismiss: true });
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal({ persistDismiss: true });
      });
    });

    function resolveMembershipVariant(product) {
      if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
      return product.variants[0];
    }

    function resolveMembershipSellingPlanId(variant) {
      var allocations = Array.isArray(variant && variant.selling_plan_allocations)
        ? variant.selling_plan_allocations
        : [];
      if (allocations.length) {
        var planId = Number(allocations[0] && allocations[0].selling_plan_id);
        if (Number.isFinite(planId) && planId > 0) return planId;
      }
      return 3513909444;
    }

    async function addMembershipToCart() {
      if (!joinBtn) return;
      if (joinBtn.disabled) return;

      var originalText = joinBtn.textContent;
      joinBtn.disabled = true;
      joinBtn.textContent = 'Adding...';

      try {
        var productRes = await fetch('/products/membership.js');
        if (!productRes.ok) throw new Error('Unable to load membership product');
        var product = await productRes.json();
        var variant = resolveMembershipVariant(product);
        if (!variant || !variant.id) throw new Error('Membership variant not found');

        if (typeof window.EGAddMembershipToCart === 'function') {
          await window.EGAddMembershipToCart(variant.id);
          closeModal({ persistDismiss: true });
          joinBtn.textContent = originalText;
          joinBtn.disabled = false;
          return;
        }

        var sellingPlanId = resolveMembershipSellingPlanId(variant);

        var addRes = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: variant.id,
                quantity: 1,
                selling_plan: sellingPlanId
              }
            ]
          })
        });

        var addData = await addRes.json();
        if (!addRes.ok) {
          throw new Error((addData && (addData.description || addData.message)) || 'Unable to add membership');
        }

        var sections = 'cart-drawer,cart-icon-bubble';
        var drawerRes = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + '?sections=' + sections);
        var drawerData = await drawerRes.json();

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({
            sections: drawerData,
            id: variant.id
          });
        }

        closeModal({ persistDismiss: true });
      } catch (_err) {
        joinBtn.textContent = 'Try Again';
        window.setTimeout(function () {
          joinBtn.textContent = originalText;
          joinBtn.disabled = false;
        }, 1200);
        return;
      }

      joinBtn.textContent = originalText;
      joinBtn.disabled = false;
    }

    if (joinBtn) {
      joinBtn.addEventListener('click', function () {
        addMembershipToCart();
      });
    }

    document.addEventListener('keydown', onKeydown);

    window.setTimeout(function () {
      if (!shouldSuppress(storageKey, cooldownHours)) {
        root.classList.add('is-visible');
      }
    }, Math.max(0, showDelayMs));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
